import { render, staticRenderFns } from "./AdsAccountHistory.vue?vue&type=template&id=cc12337c&scoped=true&"
import script from "./AdsAccountHistory.vue?vue&type=script&lang=js&"
export * from "./AdsAccountHistory.vue?vue&type=script&lang=js&"
import style0 from "./AdsAccountHistory.vue?vue&type=style&index=0&id=cc12337c&lang=scss&scoped=true&"
import style1 from "./AdsAccountHistory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc12337c",
  null
  
)

export default component.exports